import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReviewsService } from '../reviews.service';
import { BaseComponent } from '../classes/BaseComponent';
import { StorageHelper } from '../helpers/StorageHelper';
import { Global } from '../classes/Global';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  providers: [ ReviewsService, AuthenticationService ]
})
export class ReviewsComponent extends BaseComponent implements OnInit {

  @Input() reviews: any[] = [];
  @Input() idInStore;
  @Output() needAuth = new EventEmitter();

  newReviewTitle: string = "";
  newReviewText: string = "";
  newReviewRating: number = 0;
  showNewReview: boolean = false;
  editMode: boolean = false;
  editReviewId: number;

  constructor(
    private reviewsService: ReviewsService,
    private authenticationService: AuthenticationService
  ) {
    super();
  }

  ngOnInit() {
  }

  cancelReview() {
    this.editMode = false;
    this.showNewReview = false;
    this.newReviewText = "";
    this.newReviewTitle = "";
  }

  send() {
    if(this.editMode) {
      this.editReview();
    }
    else {
      this.addReview();
    }
  }

  editReview() {
    this.reviewsService.edit(this.editReviewId, this.newReviewTitle, this.newReviewText, this.newReviewRating, this.idInStore, Global.ITUNES,
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), Global.getCountry(), Global.getMediaType()).subscribe(res => {
        this.reload();
        this.newReviewTitle = "";
        this.newReviewText = "";
        this.editMode = false;
        this.showNewReview = false;
      }, err => {

      });
  }

  addReview() {
    this.reviewsService.create(this.newReviewTitle, this.newReviewText, this.newReviewRating, this.idInStore, Global.ITUNES,
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), Global.getCountry(), Global.getMediaType()).subscribe(res => {
        this.reload();
        this.newReviewTitle = "";
        this.newReviewText = "";
        this.showNewReview = false;
      }, err => {

      });
  }

  reload() {
    this.reviewsService.getReviewsForItem(this.idInStore, Global.ITUNES, Global.getCountry()).subscribe(res => {
      if(res && res['results'] && res['results'].length > 0) {//when empty, {} is received form the server...
        this.reviews = res['results'];
      }
    }, err => {

    });
  }

  onEditReview(review) {
    this.editMode = true;
    this.editReviewId = review.id;
    this.newReviewTitle = review.title;
    this.newReviewText = review.text;
    this.newReviewRating = review.rating;
    this.showNewReview = true;
  }

  openNewReview() {
    
    if(this.authenticationService.isLoggedIn()) {
      this.showNewReview = true
    }
    else {
      this.needAuth.emit();
    }

  }

}
